import React, { useState, useEffect } from "react";

export default function Alumni() {
  return (
    <div className="h-[100vh] w-[100vw] flex justify-center items-center">
      <img
        style={{ maxWidth: "150px" }}
        className="animate-bounce"
        src="/assets/images/icon/logo_unmul.png"
        alt=""
      />
    </div>
  );
}
